import { render, staticRenderFns } from "./ReAccreditation.vue?vue&type=template&id=07713908&scoped=true&"
import script from "./ReAccreditation.vue?vue&type=script&lang=js&"
export * from "./ReAccreditation.vue?vue&type=script&lang=js&"
import style0 from "./ReAccreditation.vue?vue&type=style&index=0&id=07713908&scoped=true&lang=css&"
import style1 from "./ReAccreditation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07713908",
  null
  
)

export default component.exports